import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/AppShell";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/"><BrandMark /></Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary inline-flex items-center gap-1"><ArrowLeft size={14} /> Home</Link>
        </div>
      </header>
      <article className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <div className="overline">Legal · Version 2026-02-01</div>
        <h1 className="mt-3 font-serif text-4xl md:text-5xl text-primary leading-tight">Terms of Service</h1>
        <p className="mt-4 text-muted-foreground">
          By using Arogya Pramana, you agree to these terms. This service is a healthcare trust and advocacy platform — it is
          <strong> not</strong> a substitute for professional medical advice, diagnosis, or treatment.
        </p>
        {[
          ["1. Nature of service", "Arogya Pramana publishes verified provider information, Trust Index scores, HCAHPS-based hospital ratings, and offers advocacy tools (symptom triage, records custody, appointment booking). Content is informational."],
          ["2. Medical disclaimer", "Triage recommendations are rule-based decision support. Always consult a qualified healthcare professional for medical decisions. In an emergency, dial your local emergency number immediately."],
          ["3. Account responsibilities", "You are responsible for maintaining the confidentiality of your credentials and for all activity under your account. Notify us immediately of any unauthorised use."],
          ["4. Accurate information", "Providers registering on the platform must submit accurate professional and institutional information. False data may result in verification revocation."],
          ["5. Trust Index & HCAHPS", "Ratings are computed from objective, verifiable inputs (accreditations, patient feedback, operational data). Providers may dispute a score via the grievance channel."],
          ["6. Payments", "The current MVP does not process payments; future paid features will be governed by an addendum and separately consented."],
          ["7. Intellectual property", "All platform code, design, and branding are owned by Arogya Pramana. User-generated content remains owned by the user."],
          ["8. Limitation of liability", "To the maximum extent permitted by Indian law, Arogya Pramana is not liable for indirect, incidental, or consequential damages arising from use of the service."],
          ["9. Termination", "You may delete your account at any time. We may suspend accounts for verified misuse or breach of these terms, following notice where feasible."],
          ["10. Governing law", "These terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of the courts at Mumbai."],
        ].map(([title, body]) => (
          <section key={title} className="mt-8">
            <h2 className="font-serif text-2xl text-primary">{title}</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{body}</p>
          </section>
        ))}
      </article>
    </div>
  );
}
